<template>
  <div>

    <b-alert
      show
      variant="light"
      class="alert alert-custom alert-white alert-shadow fade show gutter-b"
    >
      <div class="alert-icon">
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="/media/svg/icons/Tools/Compass.svg" />
        </span>
      </div>
      <div class="alert-text">
        Laporan Lab
      </div>
      <b-button
        squared
        variant="success"
        v-if="manipulateBtn == true"
        @click="$router.push('/lab-report/add')"
      >Tambah</b-button>
    </b-alert>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table
              :fields="fields"
              :items="items"
              purpose="master"
              :perPage="perPage"
              :currentPage="currentPage"
              :totalRows="totalRows"
              @filterByPatient="filterByPatient"
              @filter="generalFilter"
              @btnDeleteOnClick="btnDeleteOnClick"
              @pageOnClick="pageOnClick"
            />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"
import Card from '@/view/content/Card.vue'
import Table from '@/component/lab-reports/Table.vue'
import module from '@/core/modules/CrudModule.js'
import { getUser } from '@/core/services/jwt.service.js'

export default {

  components: {
    Card,
    Table
  },

  data() {
    return {
      // Filter
      filter: {
        doctor_id: '',
        patient_name: '',
        start_date: '',
        end_date: ''
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 1,
      // Table Fields
      fields: [
        {
          key: "number",
          label: '#',
          sortable: true,
        },
        {
          key: "display_date",
          label: "Tanggal",
          sortable: true,
        },
        {
          key: "patient_name",
          label: "Pasien",
          sortable: true,
        },
        {
          key: "doctor_name",
          label: "Dokter",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      manipulateBtn: false,
      // current user
      currentUser: getUser()
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      let route
      if (this.currentUser.user_type_id == 1) {
        route = `lab-reports/get-by-doctor/${this.currentUser.user_id}`
      } else {
        route = 'lab-reports'
      }
      let filterParams = `&doctor_id=${this.filter.doctor_id}&patient_name=${this.filter.patient_name}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`
      let response = await module.paginate(route, `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }
      this.items = response.data
    },

    resetFilter() {
      if (this.currentUser.user_type_id != 1) {
        this.filter.doctor_id = ''
      }
      this.filter.start_date = ''
      this.filter.end_date = ''
    },

    filterByPatient(sended) {
      this.resetFilter()
      this.filter.patient_name = sended.patient_name
      this.pagination()
    },

    generalFilter(sended) {
      this.filter.doctor_id = sended.doctor_id
      this.filter.patient_name = sended.patient_name
      this.filter.start_date = sended.start_date
      this.filter.end_date = sended.end_date
      this.pagination()
    },

    async btnDeleteOnClick(id) {
      // Delete Data
      let result = await module.delete('lab-reports/' + id)
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

    // access management
    async setActiveMenu() {

      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        // console.log("looping")

        if (access_right[a] == "1104") {
          this.manipulateBtn = true
        }

      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pemeriksaan Lab" },
      { title: "Laporan Lab" },
    ])
    // Get Table Data
    this.pagination()
    this.setActiveMenu()
  },

}
</script>

<style>
</style>